/* eslint-disable no-promise-executor-return */
/* eslint-disable @typescript-eslint/no-loop-func */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-async-promise-executor */
import moment from 'moment';
import { notification } from 'antd';
import { isEmpty, isPlainObject, pickBy } from 'lodash';

export const beforeImage5mbUpload = (file: any) => {
  const supportedFileType = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
  if (!supportedFileType) {
    notification.error({
      message: 'Sorry, we can only accept JPG, PNG or JPEG files',
      placement: 'topRight',
    });
    return false;
  }

  // TODO: some patient profile pics are more than 5 MB. So, no need to restrict file size now
  // const isValidFileSize = file.size < 1024 * 1024 * 5;
  // if (!isValidFileSize) {
  //     message.error('Sorry, image must smaller than 5MB', 5);
  //     return false;
  // }

  return true;
};

export const calculateDueIn = (createdAt: string) => {
  const date1 = moment();
  const date2 = moment(createdAt);
  let dueTime = 'overdue';
  if (date1.diff(date2, 'minutes') < 60) {
    dueTime = `${date1.diff(date2, 'minutes')} mins`;
  } else if (date1.diff(date2, 'hours') > 0 && date1.diff(date2, 'hours') < 48) {
    dueTime = `${48 - date1.diff(date2, 'hours')} hrs`;
  } else if (date1.diff(date2, 'days') < 2) {
    dueTime = `${date1.diff(date2, 'days')} days`;
  }
  return dueTime;
};

export const calculateSpecialistCaseOverdue = (dueAt: string) => {
  const today = moment();
  const expiration = moment(dueAt);

  const diff = expiration.diff(today);
  const diffDuration = moment.duration(diff);
  const diffAsHours = diffDuration.asHours();

  let text = '';
  let caseOverdueHighlightClass = '';

  if (diffAsHours > 0 && diffAsHours < 24) {
    text = `Due In ${diffDuration.hours()} ${diffDuration.hours() > 1 ? 'Hours' : 'Hour'}`;
    caseOverdueHighlightClass = 'due-in-hours';
  } else if (diffAsHours >= 24) {
    text = `Due In ${diffDuration.days()} ${diffDuration.days() === 1 ? 'Day' : 'Days'}`;
    caseOverdueHighlightClass = 'due-in-days';
  } else {
    const diffDays = -diffDuration.days();
    text += diffDays > 0 ? `Overdue by ${diffDays} Days` : '';
    caseOverdueHighlightClass = diffDays > 0 ? 'overdue-in-days' : '';
  }
  return { text: text.toUpperCase(), class: caseOverdueHighlightClass };
};

export const formatDate = (date: string | undefined, fr: string) => moment(date).format(fr);

export const roundDecimalNumber = (number: number) => {
  const roundOfNumber = Math.round(number * 10);
  return roundOfNumber / 10;
};

export const searchParams = (url: string, key: string): string | null => {
  try {
    const params = new URL(url).searchParams;
    return params.get(key);
  } catch {
    return '';
  }
};

export const upperCaseFirstLetterOfWord = (str: string) =>
  str
    ?.split(' ')
    .map((word) => word[0].toUpperCase() + word.substring(1))
    .join(' ') ?? '';

export const checkIsStlFileSizeValid = (sizeInBytes: number): boolean => sizeInBytes > 100000;

export function capitalize(s: string) {
  return s[0].toUpperCase() + s.slice(1);
}

export const discardNullUndefined = (data: object | null | undefined) => {
  if (!isPlainObject(data)) return data;
  const leanData: any = pickBy(data, (v) => v !== null && v !== undefined);
  // clean nested
  Object.entries(leanData).forEach(([key, value]) => {
    leanData[key] = isPlainObject(value) ? discardNullUndefined(value as object) : value;
  });
  return leanData;
};

export const discardEmpty = (data: object | null | undefined) => {
  if (!isPlainObject(data)) return data;
  const leanData: any = pickBy(data, (v) => !isEmpty(v));
  // clean nested
  Object.entries(leanData).forEach(([key, value]) => {
    leanData[key] = isPlainObject(value) ? discardEmpty(value as object) : value;
  });
  return leanData;
};

export const discardEmptyLevel = (data: object | null | undefined, nestedLevel: number = 1) => {
  if (nestedLevel < 1) return data;
  let ans = discardEmpty(data);
  let times = nestedLevel;

  while (times > 1 && !isEmpty(ans)) {
    ans = discardEmpty(ans);
    times -= 1;
  }

  return ans;
};

export const IPR_STAGE_OPTIONS: Array<{ value: string }> = Array.from({ length: 31 }, (_, i) => ({
  value: `Stage ${i}`,
}));

type TArguments = {
  requestFunc: () => Promise<void> | void;
  delay: number;
  maximumAttempt: number;
};

export const severalAttempts = async (arg: TArguments) =>
  new Promise(async (resolve, reject) => {
    let times = 0;
    while (true) {
      try {
        await new Promise((r) => setTimeout(r, times === 0 ? 0 : arg.delay));
        const res = await arg.requestFunc();
        resolve(res);
        break;
      } catch (e) {
        times += 1;
        if (times >= arg.maximumAttempt) {
          reject(e);
          break;
        }
      }
    }
  });
